import { clsx } from "@plans/appkit";
import { AlertTriangleIcon } from "@plans/icons/untitled-ui/AlertTriangleIcon";
import { useTranslation } from "react-i18next";

export function ErrorDisplay({
	status,
	message,
	title,
	className,
	button,
}: {
	status: number;
	title?: string;
	message?: string;
	className?: string;
	button?: React.ReactNode;
}) {
	const { t } = useTranslation(["common"]);
	return (
		<div
			className={clsx(
				"flex w-full flex-col items-center justify-center gap-3",
				className,
			)}
		>
			<AlertTriangleIcon className="h-8 w-8" />
			<h1
				className="text-xl font-semibold sm:text-3xl"
				data-cy={`${status}-page`}
			>
				{title ?? (
					<>
						{t("common:generic_error_title")} ({status})
					</>
				)}
			</h1>
			{message && (
				<p className="max-h-72 max-w-sm overflow-y-auto font-mono">{message}</p>
			)}
			{button && <div className="mt-3">{button}</div>}
		</div>
	);
}
